import * as types from '../../action-types';

export default sessionData => ({
  type: types.SET_OPTTY_SESSION_DATA,
  sessionData,
});
